import(/* webpackMode: "eager" */ "/vercel/path0/apps/fiona-main/src/app/layout.tsx");
